import DocumentIcon from './DocumentIcon';

export default DocumentIcon;
